<template>
  <div v-redirect-if-no-permission:REGISTERED_CAPTAINS>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreateConstraint' }">
        <v-btn v-if="this.$store.state.user.roles[0].name != 'Call center'" color="primary">{{ $t("surveysPage.newConstraint") }}</v-btn>
      </router-link>
    </v-layout>
    <data-table
      ref="constraintsDataTable"
      :url="api.ACTIONS.CONSTRAINTS"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      :formatter="formatters"
      perPage="100"
      :fields-hidden-main="['id', 'updated_at', 'created_at','strike_through']"
      :titles="titles"
      :actions-extra-main="actionsExtraMain"
      :disable-search="false"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Constraints",
  title() {
    return this.$t("surveysPage.constraintsTitle");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
      },
      constraints: "",
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
    };
  },
  computed: {
    titles() {
      return {
        constraint_name: this.$t("surveysPage.colConstraintName"),
        Abbreviation: this.$t("surveysPage.colAbbreviation"),
        customer_app_message: this.$t("surveysPage.colCustomerAppMessage"),
        driver_on_off: this.$t("surveysPage.canDriverEdit"),
        customer_on_off: this.$t("surveysPage.colShownInCustomerApp"),
        entity_type: this.$t("surveysPage.colType"),
        strike_through_txt: this.$t("surveysPage.colStrikeThrough"),
      };
    },
    actionsExtraMain() {
      if (this.$store.state.user.roles[0].name == 'Call center') return {};
      return {
        editConstraint: {
          title: this.$t("surveysPage.editConstraint"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditConstraint",
              params: { id: item.id },
            }),
        },
        deleteConstraint: {
          title: this.$t("surveysPage.deleteConstraint"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`dynamic_constraints/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("surveysPage.toastConstraintDeleted"),
                  "green"
                );
                this.$refs.constraintsDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("surveysPage.toastSomethingWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
